import {Payload} from "vuex";
import {ModulePath, UserActionTypes} from "@/store/modules/user.module";

export class GetUserActionPayload implements Payload {
    type: string;

    constructor() {
        this.type = ModulePath + UserActionTypes.SET_USER;
    }
}